import type { AssetScope } from "../components/gallery/galleryTree";
import type { SlimSessionRef } from "../generated/api/types.gen";

interface GalleryRouteSearch {
  projectId?: string;
  sessionId?: string;
  view?: "assets";
  scope?: AssetScope;
}

interface GalleryNavigationPayload {
  to: "/gallery";
  search: GalleryRouteSearch;
}

interface HomeNavigationPayload {
  to: "/";
  search: { projectId?: string };
}

export function selectProjectPath(projectId: string): GalleryNavigationPayload {
  return { to: "/gallery", search: { projectId } };
}

export function selectRootPath(): GalleryNavigationPayload {
  return { to: "/gallery", search: {} };
}

export function selectAssetsPath(
  scope: AssetScope = "personal",
): GalleryNavigationPayload {
  // Personal is the default — omit ``scope`` from the URL so the "My
  // Assets" link stays /gallery?view=assets and reload-stable.
  return {
    to: "/gallery",
    search:
      scope === "personal" ? { view: "assets" } : { view: "assets", scope },
  };
}

export function exitSessionPath(
  selectedProjectId: string | undefined,
): GalleryNavigationPayload {
  return {
    to: "/gallery",
    search: selectedProjectId ? { projectId: selectedProjectId } : {},
  };
}

export function startNewDesignPath(
  selectedProjectId: string | undefined,
): HomeNavigationPayload {
  return {
    to: "/",
    search: selectedProjectId ? { projectId: selectedProjectId } : {},
  };
}

export function sessionPath(
  sessionId: string,
  slimSessions: SlimSessionRef[],
  selectedProjectId: string | undefined,
): GalleryNavigationPayload {
  const sessionEntry = slimSessions.find((s) => s.session_id === sessionId);
  return {
    to: "/gallery",
    search: {
      projectId: sessionEntry?.project_id ?? selectedProjectId ?? undefined,
      sessionId,
    },
  };
}
